import { SwivlEmbed } from "@swivl-mono/chat";
import { EmbedInterface } from "@swivl-mono/types";
import { LayoutWithSidebar, Spinner } from "@swivl-mono/ui";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import { SidebarLink } from "../../../Components/SidebarLink/SidebarLink";
import { LocalStorageHelper } from "../../../Models/LocalStorage/LocalStorageHelper";

const url =
  import.meta.env.VITE_CONTEXT === "staging"
    ? "https://swivl-embed.s3.amazonaws.com/embed/index-staging.js"
    : "https://swivl-embed.s3.amazonaws.com/embed/index.js";

const iframeContent = (embedId) => {
  return `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <title>Chat</title>
    <base href="/" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link rel="icon" type="image/x-icon" href="/favicon.ico" />
    <script type="text/javascript" src="${url}"></script>
   
    

  </head>
  <body>
    <div id="root"></div>
    <script>
        
        Swivl.embed('${embedId}', {
        'server': '${import.meta.env.VITE_SERVER_URL}',
        'webSocketServer': '${import.meta.env.VITE_CHANNELS_WEBSOCKET_URL}'
        });

    </script>
    
  </body>
</html>
`;
};

interface Props {
  orgId: string;
  embedId?: string;
  embeds?: EmbedInterface[];
}
interface State {
  useEmbedCode: boolean;
}
export function EmbedTesterEmbedsView(props: Props) {
  const { orgId, embedId, embeds } = props;
  const [state, setState] = useState<State>({ useEmbedCode: LocalStorageHelper.getItem("useEmbedCode") === "true" });

  //https://swivl-embed.s3.amazonaws.com/swivl3/index.js
  // let embed = embeds?.find((embed) => embed.id === parseInt(embedId || ''));

  useEffect(() => {
    if (!embedId) {
    } else {
      setTimeout(() => {
        // (window as any).Swivl.unmount();
        (window as any).Swivl.embed(embedId || "");
        setTimeout(() => {
          (window as any).Swivl.open();
        }, 500);
      }, 3000);
    }
  }, [embedId]);
  useEffect(() => {
    return () => {
      try {
        (window as any).Swivl.unmount();
      } catch (e) {}
    };
  }, []);
  return (
    <LayoutWithSidebar
      sidebar={
        <div className="flex flex-col">
          {embeds ? (
            embeds.map((embed) => (
              <SidebarLink key={embed.id} to={`/admin/embed/${orgId}/${embed.id}`}>
                {embed.name}
              </SidebarLink>
            ))
          ) : (
            <Spinner />
          )}
        </div>
      }
      contentNoPadding={true}
      content={
        // state.useEmbedCode ?
        //   <SwivlEmbed
        //     config={undefined}
        //     embedId={""}
        //     server={""}
        //     webSocketServer={""}
        //     notificationsServer={""}
        //     swivl={undefined}
        //     embedSettings={undefined}
        //     /> :
        <iframe
          id={"IFRAME_ID"}
          name={"IFRAME_ID"}
          width={"100%"}
          height={"100%"}
          // sandbox="allow-same-origin allow-scripts"

          srcDoc={iframeContent(embedId)}
        />
      }
    />
  );
}
